export const SITE = {
  brand: "Kardeşler Yapı",
  brandShort: "Kardeşler",
  tagline: "Eskişehir'in Lüks Yalıtım & Yapı Uzmanı",
  logo: "https://customer-assets.emergentagent.com/job_kardeles-dashboard/artifacts/ams7ri9w_WhatsApp%20Image%202026-06-24%20at%2012.55.45.jpeg",
  phones: [
    { label: "0222 221 57 11", value: "+902222215711" },
    { label: "0537 546 61 56", value: "+905375466156" },
  ],
  whatsapp: "+905375466156",
  city: "Eskişehir",
  region: "Türkiye",
  address: "Mustafa Kemal Paşa, Prof. Dr. Kemal Tuncatay Sk. 1/A, 26120 Tepebaşı/Eskişehir",
  email: "info@kardesleryapi.com.tr",
  hero: "https://images.unsplash.com/photo-1624204386084-dd8c05e32226?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmFsJTIwYnVpbGRpbmclMjBkdXNrfGVufDB8fHx8MTc4MjI5NjQ5OHww&ixlib=rb-4.1.0&q=85",
  founded: 2004,
  yearsOfExperience: new Date().getFullYear() - 2004,
};

export const NAV = [
  { to: "/", label: "Anasayfa" },
  { to: "/hakkimizda", label: "Hakkımızda" },
  { to: "/hizmetlerimiz", label: "Hizmetlerimiz" },
  { to: "/#referanslar", label: "Referanslar" },
  { to: "/projelerimiz", label: "Projelerimiz" },
  { to: "/iletisim", label: "İletişim" },
];

export const SERVICES = [
  {
    slug: "su-yalitimi",
    title: "Su Yalıtımı",
    short: "Bodrum, temel, teras ve ıslak hacimler için sızdırmazlık çözümleri.",
    long:
      "Bodrum perde, temel, teras, balkon, ıslak hacim ve havuz uygulamaları için poliüretan, bitümlü membran ve kristalize çözümler. 10+ yıl ömürlü, garantili işçilik.",
    image: "https://images.unsplash.com/photo-1453586857165-eb78d44460ca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmFsJTIwYnVpbGRpbmclMjBkdXNrfGVufDB8fHx8MTc4MjI5NjQ5OHww&ixlib=rb-4.1.0&q=85",
    icon: "Droplets",
    bullets: ["Bitümlü membran", "Poliüretan kaplama", "Kristalize beton", "Su sızdırmazlık testi"],
  },
  {
    slug: "cati-yalitimi",
    title: "Çatı Yalıtımı",
    short: "Beton, ahşap ve eğimli çatılarda kalıcı izolasyon çözümleri.",
    long:
      "Eğimli, kırma ve teras çatılar için XPS, taşyünü, poliüretan köpük uygulamaları. Buhar dengeleyici membran ve nefes alan örtü sistemleri ile uzun ömürlü yalıtım.",
    image: "https://images.pexels.com/photos/8491084/pexels-photo-8491084.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    icon: "Mountain",
    bullets: ["XPS / taşyünü", "Poliüretan püskürtme", "Buhar bariyeri", "Membran örtü"],
  },
  {
    slug: "isi-yalitimi",
    title: "Isı Yalıtımı",
    short: "Mantolama ile %50'ye varan enerji tasarrufu.",
    long:
      "EPS, XPS, taşyünü ve fenolik panel ile dış cephe mantolama. TS 825 standartlarında, ısı köprülerini ortadan kaldıran detay çözümleri.",
    image: "https://images.unsplash.com/photo-1752852381113-7d93abc9d7ea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxyb29mJTIwY29uc3RydWN0aW9uJTIwaW5zdWxhdGlvbiUyMGJ1aWxkaW5nfGVufDB8fHx8MTc4MjI5NjQ5OHww&ixlib=rb-4.1.0&q=85",
    icon: "Thermometer",
    bullets: ["Dış cephe mantolama", "İç cephe yalıtım", "Akustik panel", "Isı köprüsü çözümü"],
  },
  {
    slug: "cati-tadilat-onarim",
    title: "Çatı Tadilat & Onarım",
    short: "Aktarma, kiremit değişimi, oluk ve mahya bakım onarımı.",
    long:
      "Mevcut çatılarda aktarma, kiremit & sandviç panel değişimi, oluk yenileme, mahya, dere ve baca onarımı. Hızlı keşif, garantili müdahale.",
    image: "https://images.unsplash.com/photo-1673978482989-5eb3b350be2d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHw0fHxyb29mJTIwY29uc3RydWN0aW9uJTIwaW5zdWxhdGlvbiUyMGJ1aWxkaW5nfGVufDB8fHx8MTc4MjI5NjQ5OHww&ixlib=rb-4.1.0&q=85",
    icon: "Hammer",
    bullets: ["Çatı aktarma", "Kiremit / panel", "Oluk & mahya", "Dere & baca onarım"],
  },
];

export const STATS = [
  { value: "500+", label: "Tamamlanan Proje" },
  { value: "20+", label: "Yıllık Tecrübe" },
  { value: "%100", label: "Müşteri Memnuniyeti" },
  { value: "10Y", label: "İşçilik Garantisi" },
];
